import {filter, map} from 'rxjs/operators';
import {Action} from 'redux';
import {RESET_DATA_START} from '../actionConstants';
import {resetData} from '../actions';
import {Observable} from 'rxjs';

export const resetDataStartEpic = (action$: Observable<Action>) =>
  action$.pipe(
    filter((action: Action) => action.type === RESET_DATA_START),
    map(resetData),
  );
